import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

type DateFieldProps = TextFieldProps & {
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function DateField(props: DateFieldProps) {
  const { validateIsNotEmpty = false, handleChange, handleBlur, ...rest } = props;

  return (
    <MuiTextField
      variant='standard'
      type='date'
      fullWidth
      required={validateIsNotEmpty || false}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(event) => handleChange(event.target.value)}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
      }}
      {...rest}
    />
  );
}

export type { DateFieldProps };

export default DateField;
